import { BasicSelectField } from 'lib/iterable-hook-form';
import { get } from 'lodash';
import { mapRegions } from 'modules/messagingInsights/constants';
import { PDFReportFormStateValues } from 'modules/messagingInsights/schema';
import { useFormContext } from 'react-hook-form';
import { LocationFormFieldContainer } from './Styled';

type Props = {
  fieldName: string;
  fieldPlaceholder: string;
};

export const LocationFormField = ({ fieldName, fieldPlaceholder }: Props) => {
  const {
    formState: { errors },
  } = useFormContext<PDFReportFormStateValues>();

  const errorText = get(errors, `${fieldName}.message`, '').toString();
  const hasError = !!get(errors, fieldName);

  return (
    <LocationFormFieldContainer
      data-test="location-settings"
      errorText={errorText}
      hasError={hasError}
    >
      <BasicSelectField name={fieldName} options={mapRegions} placeholder={fieldPlaceholder} />
    </LocationFormFieldContainer>
  );
};
